export default __webpack_public_path__ + "static/media/contentArtefacts.fa59915d.svg";